import { Accordion as AccordionComponent } from "@2u-landing-pages/components/Accordion";
import { ContentLayout } from "@2u-landing-pages/components/ContentLayout";
import { TemplateWrapper } from "@2u-landing-pages/components/TemplateWrapper";
import { Container, Flex } from "@red-digital/bricks";
import cn from "classnames";
import React from "react";
import { AccordionProps, CustomCSSProperties } from "../../Accordion.type";
// @ts-ignore
import styles from "./Default.module.scss";

export const Default: React.FC<AccordionProps> = ({
  sectionName,
  section_heading,
  orientation = "vertical",
  split_configuration = "50/50",
  items,
  section_background_color,
  id,
  accordion_item_heading_color,
  active_background_color,
  active_text_color,
  inactive_background_color,
  inactive_text_color,
  items_visible,
  active_border_color,
  inactive_border_color,
  phoneNumber,
}) => {
  const style: CustomCSSProperties = {};

  if (accordion_item_heading_color) style["--item-heading-color"] = `var(${accordion_item_heading_color})`;
  if (active_background_color) style["--active-background-color"] = `var(${active_background_color})`;
  if (active_text_color) style["--active-text-color"] = `var(${active_text_color})`;
  if (inactive_background_color) style["--inactive-background-color"] = `var(${inactive_background_color})`;
  if (inactive_text_color) style["--inactive-text-color"] = `var(${inactive_text_color})`;
  if (active_border_color) style["--active-border-color"] = `var(${active_border_color})`;
  if (inactive_border_color) style["--inactive-border-color"] = `var(${inactive_border_color})`;

  return (
    <TemplateWrapper
      padded
      backgroundColor={section_background_color}
      id={id}
      style={style}
      className={cn("accordion-wrapper", {
        [styles.horizontal]: orientation === "horizontal",
      })}
    >
      <Flex
        className={cn(styles.accordion, {
          [styles.split_50_50]: split_configuration === "50/50",
          [styles.split_70_30]: split_configuration === "70/30",
          [styles.split_30_70]: split_configuration === "30/70",
        })}
        topSlot={
          <Container
            flex
            justifyContent="center"
            style={orientation !== "horizontal" ? { textAlign: "center", marginBottom: "20px" } : undefined}
          >
            <ContentLayout
              content={section_heading}
              heading={{
                variant: "heading-2xl",
              }}
              phoneNumber={phoneNumber}
            />
          </Container>
        }
      >
        <AccordionComponent
          items={items}
          itemsVisible={items_visible}
          sectionName={sectionName}
          orientation={orientation}
          phoneNumber={phoneNumber}
        />
      </Flex>
    </TemplateWrapper>
  );
};
